import styled, { css } from 'styled-components';
import { border, common, flex, space, typography } from 'styles/setting';

export const mixed = css`
  ${border}
  ${common}
  ${flex}
  ${space}
`;

export const Box = styled.div`
  ${mixed}
`;

export const RowBox = styled(Box)`
  display: flex;
`;

export const ColBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const CenterRowBox = styled(RowBox)`
  justify-content: center;
  align-items: center;
`;

export const BetweenRowBox = styled(RowBox)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CenterColBox = styled(ColBox)`
  justify-content: center;
  align-items: center;
`;

export const Line = styled.span`
  display: inline-block;
  margin: 0 8px;
  width: 1px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.white15};
`;

export const Container = styled.div`
  padding: 8px 16px;
  ${mixed}
`;

export const Card = styled(Box)`
  display: flex;
  padding: ${({ $padding }) => $padding || '16px'};
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.fill12};
`;

// list
export const ColList = styled.ul`
  display: flex;
  flex-direction: column;
  ${mixed}
`;

export const RowListItem = styled.li`
  display: flex;
  ${mixed}
`;

// typo
export const H2 = styled.h2`
  ${mixed}
  ${typography}
`;

export const Text = styled.p`
  ${mixed}
  ${typography}
`;

export const Span = styled.span`
  ${mixed}
  ${typography}
`;

export const ChipText = styled(Text)`
  padding: 4px 8px;
  border-radius: 100px;
  color: white;
  font-size: 14px;
  line-height: 1;
  width: fit-content;
`;
